export const SupportingPagesRoutesConfig = {
  accessDenied: "/access-denied",
} as const;
